import { Component } from '@angular/core';
import { BiqButtonComponent } from '../biq-button/biq-button.component';
import { analytics } from '@app/events/segment/analytics';
import { Router } from '@angular/router';

@Component({
  selector: 'app-biq-end-page',
  imports: [
    BiqButtonComponent,
  ],
  templateUrl: './end-page.component.html',
  styleUrl: './end-page.component.css'
})
export class EndPageComponent {

  constructor(private router: Router) {}

  onClickBtn() {
    analytics.track('BIQ Exit',{section : 'biq'});
    this.router.navigate(['/survey']);
  }
}
